<template>
  <!-- NOTIFICATIONS -->
  <div>
    <Modal v-if="popupCancelMission" @closeModal="closePopup()">
      <template v-slot:icon>
        <vs-alert
          :active="errMsg"
          color="danger"
          icon="new_releases"
          class="mb-3"
        >
          <span>
            {{
              error_msg ? error_msg : "حدث خطأ ما برجاء المحاولة مره اخري"
            }}</span
          >
        </vs-alert>
        <svg
          width="91"
          height="91"
          viewBox="0 0 91 91"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M45.5 91C70.629 91 91 70.629 91 45.5C91 20.371 70.629 0 45.5 0C20.371 0 0 20.371 0 45.5C0 70.629 20.371 91 45.5 91Z"
            fill="#E80505"
            fill-opacity="0.1"
          />
          <path
            d="M58.385 34.2271L56.116 36.4861C56.86 37.2283 57.4502 38.1101 57.853 39.0808C58.2557 40.0515 58.463 41.0921 58.463 42.1431C58.463 43.194 58.2557 44.2346 57.853 45.2053C57.4502 46.176 56.86 47.0578 56.116 47.8001L58.385 50.069C59.4254 49.029 60.2508 47.7941 60.8139 46.435C61.377 45.0759 61.6668 43.6192 61.6668 42.1481C61.6668 40.6769 61.377 39.2202 60.8139 37.8611C60.2508 36.502 59.4254 35.2671 58.385 34.2271Z"
            fill="#E80505"
          />
          <path
            d="M62.912 29.8662L60.683 32.0952C63.3434 34.7623 64.8375 38.3756 64.8375 42.1427C64.8375 45.9098 63.3434 49.5232 60.683 52.1902L62.912 54.4192C64.525 52.8074 65.8045 50.8935 66.6775 48.787C67.5506 46.6805 67.9999 44.4225 67.9999 42.1422C67.9999 39.862 67.5506 37.604 66.6775 35.4975C65.8045 33.3909 64.525 31.4771 62.912 29.8652V29.8662Z"
            fill="#E80505"
          />
          <path
            d="M52.286 38.224V28H49.143L39.714 35.857H27.143L24 37.429V48.429L27.143 50L35 62.575H39.714L36.768 50H39.714L49.143 56.286H52.286V46.062C53.2048 45.9195 54.037 45.4383 54.6187 44.7129C55.2004 43.9876 55.4895 43.0708 55.429 42.143C55.4895 41.2152 55.2004 40.2984 54.6187 39.5731C54.037 38.8477 53.2048 38.3665 52.286 38.224Z"
            fill="#E80505"
          />
        </svg>
      </template>
      <template v-slot:content>
        <p class="modal-content">تأكيد الإلغاء</p>
      </template>
      <template v-slot:first-btn>
        <button class="first-btn">
          <span @click="cancelMission()">نعم تم الالغاء</span>
        </button>
      </template>
      <template v-slot:second-btn>
        <button @click="createNewTicket()" v-if="!loadingSubmitTicket">
          لا لم يتم الالغاء
        </button>
        <button v-else class="flex justify-center"><spinner-color /></button>
      </template>
    </Modal>

    <Modal v-if="popupNotification" @closeModal="closePopup()">
      <template v-slot:content>
        <div class="modal-content mb-0">
          <div v-if = "popupNotificationData.img != null && popupNotificationData.img != ''">
            <SkeletonLoading
              :width="273"
              :height="273"
              :borderRadius="4"
              v-if="imgLoading"
            />
            <img
              v-show="!imgLoading"
              :style="{ maxWidth: '273px' }"
              :src="cdnUrl + popupNotificationData.img"
              alt="Notification Image"
              @load="onImageLoad"
            />
          </div>
          <h4 v-if = "popupNotificationData.message">{{ popupNotificationData.message }}</h4>
          <h5 v-if = "popupNotificationData.redirect_url != null && popupNotificationData.redirect_url != ''" >
            <a :href="popupNotificationData.redirect_url" target="_blank">
              click here
            </a>
          </h5>  
        </div>
      </template>
    </Modal>

    <Modal v-if="popupMandatoryNotification" @closeModal="closeMandatoryPopup(popupMandatoryNotificationData)">
      <template v-slot:content>
        <div class="modal-content mb-0">
          <div v-if = "popupMandatoryNotificationData.img != null && popupMandatoryNotificationData.img != ''">
            <SkeletonLoading
              :width="273"
              :height="273"
              :borderRadius="4"
              v-if="imgLoading"
            />
            <img
              v-show="!imgLoading"
              :style="{ maxWidth: '273px' }"
              :src="cdnUrl + popupMandatoryNotificationData.img"
              alt="Notification Image"
              @load="onImageLoad"
            />
          </div>
          <h4 v-if = "popupMandatoryNotificationData.message">{{ popupMandatoryNotificationData.message }}</h4>
          <h5 v-if = "popupMandatoryNotificationData.redirect_url != null && popupMandatoryNotificationData.redirect_url != ''" >
            <a :href="popupMandatoryNotificationData.redirect_url" target="_blank">
              click here
            </a>
          </h5>  
        </div>
      </template>
    </Modal>
    <ModalNotification v-if="showRequestsModal && checkAuthHasShowModalChangePrice">
      <template v-slot:content v-if="orderRequestsData != undefined">
        <div class="modal-content flex items-center"> 
             <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.2197 0.219672L16.5 3.93939V1.74994C16.5 1.55103 16.421 1.36026 16.2803 1.21961C16.1397 1.07896 15.9489 0.999942 15.75 0.999942C15.5511 0.999942 15.3603 1.07896 15.2197 1.21961C15.079 1.36026 15 1.55103 15 1.74994V5.74994C15.0008 5.94862 15.08 6.13895 15.2205 6.27943C15.361 6.41992 15.5513 6.49918 15.75 6.49994H19.75C19.9489 6.49994 20.1397 6.42092 20.2803 6.28027C20.421 6.13962 20.5 5.94885 20.5 5.74994C20.5 5.55103 20.421 5.36026 20.2803 5.21961C20.1397 5.07896 19.9489 4.99994 19.75 4.99994H17.5606L21.2803 1.28021C21.4201 1.1394 21.4983 0.948925 21.498 0.750508C21.4976 0.55209 21.4186 0.361902 21.2783 0.2216C21.138 0.081297 20.9479 0.00231572 20.7494 0.00195437C20.551 0.00159302 20.3605 0.0798811 20.2197 0.219672Z" fill="black"/>
              <path d="M10.75 7.86377C11.0331 7.86406 11.3047 7.97664 11.5049 8.17683C11.7052 8.37702 11.8179 8.64847 11.8183 8.93164C11.8183 9.13055 11.8974 9.32132 12.038 9.46197C12.1787 9.60262 12.3694 9.68164 12.5683 9.68164C12.7672 9.68164 12.958 9.60262 13.0987 9.46197C13.2393 9.32132 13.3183 9.13055 13.3183 8.93164C13.3164 8.38349 13.1387 7.85042 12.8114 7.4107C12.4841 6.97097 12.0245 6.64776 11.5 6.48853V5.75C11.5 5.55109 11.421 5.36032 11.2803 5.21967C11.1397 5.07902 10.9489 5 10.75 5C10.5511 5 10.3603 5.07902 10.2196 5.21967C10.079 5.36032 9.99998 5.55109 9.99998 5.75V6.48853C9.41158 6.66675 8.90695 7.05071 8.57827 7.57027C8.24959 8.08982 8.1188 8.71028 8.20979 9.3183C8.30078 9.92632 8.60749 10.4813 9.07387 10.8819C9.54026 11.2824 10.1352 11.5018 10.75 11.5C10.9612 11.5 11.1677 11.5627 11.3433 11.6801C11.5189 11.7975 11.6558 11.9643 11.7366 12.1595C11.8174 12.3546 11.8385 12.5694 11.7973 12.7766C11.7561 12.9837 11.6544 13.174 11.505 13.3234C11.3556 13.4728 11.1653 13.5745 10.9582 13.6157C10.751 13.6569 10.5363 13.6358 10.3411 13.555C10.1459 13.4742 9.97911 13.3373 9.86173 13.1617C9.74434 12.9861 9.68166 12.7796 9.68161 12.5684C9.68161 12.3694 9.6026 12.1787 9.46195 12.038C9.32129 11.8974 9.13053 11.8184 8.93161 11.8184C8.7327 11.8184 8.54194 11.8974 8.40129 12.038C8.26063 12.1787 8.18161 12.3694 8.18161 12.5684C8.18359 13.1165 8.36127 13.6496 8.68854 14.0893C9.01582 14.529 9.47546 14.8522 9.99998 15.0115V15.75C9.99998 15.9489 10.079 16.1397 10.2196 16.2803C10.3603 16.421 10.5511 16.5 10.75 16.5C10.9489 16.5 11.1397 16.421 11.2803 16.2803C11.421 16.1397 11.5 15.9489 11.5 15.75V15.0115C12.0884 14.8332 12.593 14.4493 12.9217 13.9297C13.2504 13.4102 13.3812 12.7897 13.2902 12.1817C13.1992 11.5737 12.8925 11.0187 12.4261 10.6181C11.9597 10.2176 11.3648 9.99816 10.75 10C10.6094 10.0004 10.4702 9.97312 10.3402 9.91963C10.2103 9.86615 10.0921 9.78754 9.99259 9.68831C9.89306 9.58909 9.81409 9.47119 9.76021 9.34139C9.70632 9.21159 9.67859 9.07243 9.67859 8.93188C9.67859 8.79134 9.70632 8.65218 9.76021 8.52238C9.81409 8.39257 9.89306 8.27468 9.99259 8.17546C10.0921 8.07623 10.2103 7.99762 10.3402 7.94414C10.4702 7.89065 10.6094 7.86334 10.75 7.86377Z" fill="black"/>
              <path d="M20.75 10C20.5511 10.0001 20.3604 10.0791 20.2197 10.2197C20.0791 10.3604 20.0001 10.5511 20 10.75C20 12.5795 19.4575 14.3679 18.4411 15.889C17.4247 17.4102 15.98 18.5958 14.2898 19.2959C12.5996 19.996 10.7397 20.1792 8.94542 19.8223C7.15109 19.4654 5.5029 18.5844 4.20927 17.2907C2.91563 15.9971 2.03465 14.3489 1.67774 12.5546C1.32083 10.7603 1.50401 8.90039 2.20412 7.21018C2.90423 5.51996 4.08983 4.07531 5.61098 3.05891C7.13213 2.0425 8.92053 1.5 10.75 1.5C10.9489 1.5 11.1397 1.42098 11.2803 1.28033C11.421 1.13968 11.5 0.948912 11.5 0.75C11.5 0.551088 11.421 0.360322 11.2803 0.21967C11.1397 0.0790177 10.9489 0 10.75 0C8.62386 0 6.54545 0.630477 4.77762 1.8117C3.0098 2.99293 1.63194 4.67185 0.8183 6.63615C0.0046578 8.60046 -0.208228 10.7619 0.206563 12.8472C0.621354 14.9325 1.64519 16.848 3.14861 18.3514C4.65202 19.8548 6.56749 20.8787 8.65278 21.2934C10.7381 21.7082 12.8995 21.4953 14.8639 20.6817C16.8282 19.8681 18.5071 18.4902 19.6883 16.7224C20.8695 14.9546 21.5 12.8761 21.5 10.75C21.5 10.5511 21.4209 10.3604 21.2803 10.2197C21.1396 10.0791 20.9489 10.0001 20.75 10Z" fill="black"/>
            </svg>
            <span class="mx-2">
              طلب تغير سعر الطرد رقم {{ orderRequestsData.order.code }}
            </span>
      </div>
        <div class="w-full px-5" style="border: 0.5px solid #9E9E9E;border-radius: 3px; line-height: 3;">
          <p>اسم المستلم : <span class="font-bold">{{ orderRequestsData.order.receiver }}</span></p>
          <p>رقم المستلم : <span class="font-bold">{{ orderRequestsData.order.phone1 }}</span></p>
          <p>محتوي الطرد : <span class="font-bold">{{ orderRequestsData.order.order_summary }}</span></p>
          <p>المحافظه : <span class="font-bold">{{ orderRequestsData.order.government_name }}</span></p>
          <p>المنطقه : <span class="font-bold">{{ orderRequestsData.order.area }}</span></p>
          <p>السعر القديم : <span class="font-bold">{{ orderRequestsData.order_amount }}</span></p>
          <p class="text-danger font-extrabold">السعر الجديد : <span class="font-extrabold">{{ orderRequestsData.new_amount
              }}</span></p>
          <p v-if="orderRequestsData.captain_notes">ملاحظات المندوب : <span class="font-bold">{{ orderRequestsData.captain_notes }}</span></p>        
        </div>
        <div class="w-full mt-8 mb-3" v-if="orderRequestsData.partial_return">
          <h3 class="pr-5" style="font-size: medium">{{ $t("has_partial_returned") }}</h3>
        </div>
      </template>
      <template v-slot:first-btn v-if="orderRequestsData != undefined">
        <button 
          class="third-btn px-12 mt-5 text-white w-1/2 rounded-full" 
          style="background-color: #31006F;"
          :disabled="spin"
          @click="changeStatusOrderChangeRequestsPrice(true)">
            <span v-if="!spin">اوافق</span>
            <span v-else>
              <i class="fas fa-spinner fa-spin"></i> جاري المعالجة...
            </span>        
        </button>
      </template>
      <template v-slot:third-btn v-if="orderRequestsData != undefined">
        <button 
          class="third-btn mt-5 px-10 w-1/2 rounded-full" 
          :disabled="spin"
          @click="changeStatusOrderChangeRequestsPrice(false)">
            <span v-if="!spin">لا اوافق</span>
            <span v-else>
              <i class="fas fa-spinner fa-spin"></i> جاري المعالجة...
            </span>        
        </button>
      </template>

      <template v-slot:custom-message v-else>
        <i class="close-icon mr-0" @click="closePopup()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path
              id="Icon_ionic-md-close"
              data-name="Icon ionic-md-close"
              d="M23.523,9.123l-1.6-1.6-6.4,6.4-6.4-6.4-1.6,1.6,6.4,6.4-6.4,6.4,1.6,1.6,6.4-6.4,6.4,6.4,1.6-1.6-6.4-6.4Z"
              transform="translate(-7.523 -7.523)"
              fill="#212121"
            />
          </svg>
        </i>
          <p v-if="pressedOnNotification === true" class="modal-content">{{ $t("theActionAlreadyExecuted") }}</p>
          <p v-else class="modal-content">{{ $t("NotHaveNewRequests") }}</p>
      </template>
    </ModalNotification>
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer"
      ref="dropdownMenu"
      @click="
        (newNotifications = false),
          googleEventTrack(
            'الضعط على ايقون الاشعارات',
            'navbar',
            'notification_icon_in_navbar'
          )
      "
    >
      <!--  :badge="notfication.length" -->
      <span v-if="newNotifications" class="badge-ntf"></span>
      <feather-icon icon="BellIcon" class="cursor-pointer mt-1 mr-5 ml-5" />
      <vs-dropdown-menu
        class="notification-dropdown dropdown-custom vx-navbar-dropdown"
        v-if="allNotifications.length != 0"
      >
        <div class="notification-top text-center p-5">
          <p>مركز الإشعارات</p>
        </div>

        <component
          :is="scrollbarTag"
          ref="mainSidebarPs"
          class=""
          :settings="settings"
          :key="$vs.rtl"
        >
          <div
            @scroll="handleScroll"
            class="scroll-area--nofications-dropdown p-0 mb-10"
          >
            <ul class="bordered-items">
              <li
                @click="clickNotfication(ntf)"
                v-for="ntf in allNotifications"
                :key="ntf.index"
                class="flex justify-between px-4 py-4 notification cursor-pointer"
              >
                <div class="flex items-start">
                  <svg
                    v-if="ntf.img"
                    width="22"
                    height="21"
                    viewBox="0 0 22 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 7.37722C1 7.0269 1 6.85174 1.01462 6.70421C1.1556 5.28127 2.28127 4.1556 3.70421 4.01462C3.85174 4 4.03636 4 4.40558 4C4.54785 4 4.61899 4 4.67939 3.99634C5.45061 3.94963 6.12595 3.46288 6.41414 2.746C6.43671 2.68986 6.45781 2.62657 6.5 2.5C6.54219 2.37343 6.56329 2.31014 6.58586 2.254C6.87405 1.53712 7.54939 1.05037 8.32061 1.00366C8.38101 1 8.44772 1 8.58114 1H13.4189C13.5523 1 13.619 1 13.6794 1.00366C14.4506 1.05037 15.126 1.53712 15.4141 2.254C15.4367 2.31014 15.4578 2.37343 15.5 2.5C15.5422 2.62657 15.5633 2.68986 15.5859 2.746C15.874 3.46288 16.5494 3.94963 17.3206 3.99634C17.381 4 17.4521 4 17.5944 4C17.9636 4 18.1483 4 18.2958 4.01462C19.7187 4.1556 20.8444 5.28127 20.9854 6.70421C21 6.85174 21 7.0269 21 7.37722V15.2C21 16.8802 21 17.7202 20.673 18.362C20.3854 18.9265 19.9265 19.3854 19.362 19.673C18.7202 20 17.8802 20 16.2 20H5.8C4.11984 20 3.27976 20 2.63803 19.673C2.07354 19.3854 1.6146 18.9265 1.32698 18.362C1 17.7202 1 16.8802 1 15.2V7.37722Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11 15.5C13.2091 15.5 15 13.7091 15 11.5C15 9.29086 13.2091 7.5 11 7.5C8.79086 7.5 7 9.29086 7 11.5C7 13.7091 8.79086 15.5 11 15.5Z"
                      stroke="black"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    class="mt-1"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="22"
                    height="21"
                    viewBox="0 0 16.017 16.017"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <path
                          id="Path_1821"
                          data-name="Path 1821"
                          d="M10.735-4.241A2.194,2.194,0,0,1,8.842-3.149,2.055,2.055,0,0,1,7.75-3.441a2.115,2.115,0,0,1-.8-.8A.737.737,0,0,1,7.24-5.261.737.737,0,0,1,8.26-4.97c.073.073.146.218.291.291A.737.737,0,0,0,9.57-4.97a.806.806,0,0,1,1.019-.291C10.953-5.115,10.953-4.606,10.735-4.241Zm6.116-3.276a.688.688,0,0,1-.728.728H1.561a.688.688,0,0,1-.728-.728.688.688,0,0,1,.728-.728A1.46,1.46,0,0,0,3.018-9.7v-3.64a5.842,5.842,0,0,1,5.824-5.824,5.842,5.842,0,0,1,5.824,5.824V-9.7a1.46,1.46,0,0,0,1.456,1.456A.688.688,0,0,1,16.851-7.518Zm-3.276-.728A3.314,3.314,0,0,1,13.21-9.7v-3.64a4.381,4.381,0,0,0-4.368-4.368,4.381,4.381,0,0,0-4.368,4.368V-9.7A3.314,3.314,0,0,1,4.11-8.246Z"
                          transform="translate(-0.833 19.167)"
                          fill="none"
                        />
                      </clipPath>
                      <clipPath id="clip-path-2">
                        <rect
                          id="Rectangle_1001"
                          data-name="Rectangle 1001"
                          width="19.221"
                          height="19.221"
                          fill="none"
                        />
                      </clipPath>
                      <clipPath id="clip-path-3">
                        <path
                          id="Path_1820"
                          data-name="Path 1820"
                          d="M0-2.527H17.473V-20H0Z"
                          transform="translate(0 20)"
                          fill="none"
                        />
                      </clipPath>
                    </defs>
                    <g
                      id="Group_1559"
                      data-name="Group 1559"
                      transform="translate(-0.833 19.167)"
                    >
                      <g
                        id="Group_1557"
                        data-name="Group 1557"
                        transform="translate(0.833 -19.167)"
                        clip-path="url(#clip-path)"
                      >
                        <g
                          id="Group_1556"
                          data-name="Group 1556"
                          transform="translate(-1.602 -1.602)"
                          style="mix-blend-mode: normal; isolation: isolate"
                        >
                          <g
                            id="Group_1555"
                            data-name="Group 1555"
                            clip-path="url(#clip-path-2)"
                          >
                            <g
                              id="Group_1554"
                              data-name="Group 1554"
                              transform="translate(0.874 0.874)"
                              clip-path="url(#clip-path-3)"
                            >
                              <path
                                id="Path_1818"
                                data-name="Path 1818"
                                d="M-1-21H18.221V-1.779H-1Z"
                                transform="translate(0.126 20.126)"
                              />
                              <path
                                id="Path_1819"
                                data-name="Path 1819"
                                d="M-1-21H18.221V-1.779H-1Z"
                                transform="translate(0.126 20.126)"
                                fill="#212121"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <div class="mx-2">
                    <span
                      class="font-medium block notification-title"
                      :class="[`text-primary`]"
                      >{{ ntf.message }}</span
                    >
                    <small>{{ ntf.notification_date }}</small>
                  </div>
                </div>
                <small class="mt-1 whitespace-no-wrap">{{
                  ntf.notification_time
                }}</small>
              </li>
              <li class="p-6 loading-table" v-if="loadNotification">
                <spinner-color />
              </li>
            </ul>
          </div>
        </component>
        <vs-dropdown-item to="/notifications" class="m-0 p-0">
          <div
            class="checkout-footer fixed bottom-0 rounded-b-lg text-primary w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
          >
            <span>{{ $t("showAllNotfications") }}</span>
          </div>
        </vs-dropdown-item>
      </vs-dropdown-menu>
      <vs-dropdown-menu
        class="notification-dropdown dropdown-custom vx-navbar-dropdown"
        v-else
      >
        <div
          style="height: 370px"
          class="flex items-center justify-center no-notification"
        >
          <div class="no-notification-img">
            <img src="@/assets/images/elements/no-notification.png" />
          </div>
          <h5>عفواً! لا يوجد إشعارات الان</h5>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapActions, mapGetters } from "vuex";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import notify from "@/mixins/helper.js";
import Modal from "@/layouts/components/Modal.vue";
import ModalNotification from "@/layouts/components/ModalNotification.vue";
import ModalRate from "@/layouts/components/ModalRate.vue";
import notificationClick from "../../../../mixins/notificationClick";
import gTag from "@/mixins/gtag.js";
import clientPermissions from "@/mixins/clientPermissions";

export default {
  mixins: [notify, notificationClick, gTag, clientPermissions],
  components: {
    VuePerfectScrollbar,
    SpinnerColor,
    Modal,
    ModalNotification,
    ModalRate,
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      loadNotification: false,
      newNotifications: false,
      allNotifications: [],
      showRequestsModal: false,
      pressedOnNotification: false,
      orderRequestsData: {},
      credentials: {
        pageNum: 1,
        itemsPerPage: 10,
        type: "",
      },
    };
  },
  computed: {
    ...mapGetters("dataList", ["notfication", "success_api", "message", "unread_mandatory_view_notification"]),
    ...mapGetters("ticket", ["success", "error_msg", "live_ticket"]),
    ...mapGetters("userData", [
      "user",
      "sub_user",
      "is_main_client",
    ]),
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
    checkAuthHasShowModalChangePrice() {
      return this.can("price_change_requests");
    },
  },
  methods: {
    ...mapActions("dataList", ["fetchNotfication", "rateOrder", "fetchUnreadMandatoryViewNotfication"]),
    ...mapActions("ticket", ["createTicket"]),
    ...mapActions("userData", ["fetchUserData"]),
    async handleScroll(el) {
      if (this.notfication.length == 0) {
        return false;
      } else if (
          el.srcElement.offsetHeight + el.srcElement.scrollTop >=
          el.srcElement.scrollHeight
        ) {
          this.credentials.pageNum++;
          this.loadNotification = true;
          await this.fetchNotfication(this.credentials);
          this.loadNotification = false;
          this.allNotifications = this.allNotifications.concat(
            this.notfication
          );
        }
    },
    async getOrderChangeRequestsPrice(orderId = null) {
        await this.fetchUserData();
        if (!this.checkAuthHasShowModalChangePrice) {
            this.showRequestsModal = false;
            return;
        }
        if(orderId) {
          this.pressedOnNotification = true;
        }
        
        let {data} = await Axios.get(process.env.VUE_APP_BASE_URL + 'order/get_order_change_requests', {params:{order_id:orderId}});        
        if (data.order_change_requests != undefined) {
          this.showRequestsModal = true;
          
          this.orderRequestsData = data.order_change_requests[0];          
        } else {
            this.showRequestsModal = false;
        }
    },
    async changeStatusOrderChangeRequestsPrice(isAccepted) {
      this.spin = true;
      try {
        let { data } = await Axios.post(
          process.env.VUE_APP_BASE_URL + 'order/process_order_change_requests',
          {
            order_id: this.orderRequestsData.order_id,
            accept: isAccepted,
            partial_return: this.orderRequestsData.partial_return,
            socket_id: this.$socket.id
          }
        );
        if (data.success) {
          this.$vs.notify({
            title: 'نجاح',
            text: data.message,
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check',
          });
        } else {
          this.$vs.notify({
            title: 'خطأ',
            text: data.message || 'حدث خطأ أثناء تنفيذ العملية',
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-triangle',
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: 'خطأ في الاتصال',
          text: (error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'تعذر الاتصال بالخادم، حاول مرة أخرى لاحقًا',          
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-octagon',
        });
      } finally {
        await this.getOrderChangeRequestsPrice();
        this.spin = false;
      }
    },
    closePopup() {
      this.showRequestsModal = false;
      this.popupCancelMission = false;
      this.popupRate = false;
      this.popupNotification = false;
      this.errMsg = false;
      this.popupMandatoryNotification = false;
    },
  },
  beforeDestroy() {
    // Clean up the socket listener when the component is destroyed
    this.$socket.off('close-modal-for-users-when-user-take-action');
  },
  async mounted() {
    this.$socket.emit("join", { name: 'close-modal-for-users-when-user-take-action' });
    this.$socket.on('close-modal-for-users-when-user-take-action', () => {
      this.showRequestsModal = false;
    });
    window.customEvents.$on('orderRequestChangeOpen', async (data) => {
        await this.getOrderChangeRequestsPrice(data.orderId)
    });
    const userId = JSON.parse(localStorage.getItem("userData")).userId;
    this.$socket.emit("join", { name: `notification-${userId}-created` });
    this.$socket.on(`notification-${userId}-created`, (data) => {
      if (data.body.type == 'App\\Models\\OrderChangeRequest') {
        this.getOrderChangeRequestsPrice(data.body.notifiable_id);
      }
      let messageNotify, messageTitle;
      if (data.body.ticket_id) {
        messageTitle = `تذكرة رقم ${data.body.ticket_id}`;
        messageNotify = data.body.message;
      } else {
        messageNotify = data.body.message;
        if (data.body.description) {
          messageNotify = data.body.description;
        }
        if (data.body.report_name) {
          messageTitle = data.body.report_name;
        } else {
          messageTitle = data.body.title;
        }
        this.allNotifications.unshift(data.body);
        this.newNotifications = true;
      }
      this.notifyMe(messageNotify, messageTitle, data.body.img);
    });
  },
  unmounted() {
    const userId = JSON.parse(localStorage.getItem("userData")).userId;
    this.$socket.emit("leave", { name: `notification-${userId}-created` });
    this.$socket.off(`notification-${userId}-created`);
  },
  async created() {
    await this.fetchNotfication(this.credentials);
    this.allNotifications = this.notfication.slice();
    await this.fetchUnreadMandatoryViewNotfication();
  },
};
</script>
<style lang="scss">
.feather-icon-badge {
  background-color: #ea4242 !important;
  color: #fff;
}
.dropdown-custom .vs-dropdown--menu--after {
  background-color: #31006f1a !important;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";
@import "@/assets/scss/vuexy/_variables.scss";
.scroll-area--nofications-dropdown::-webkit-scrollbar {
  width: 0.25rem;
}

.scroll-area--nofications-dropdown::-webkit-scrollbar-track {
  background: #dddddd70;
}

.scroll-area--nofications-dropdown::-webkit-scrollbar-thumb {
  background: #b1b1b1;
}
.scroll-area--nofications-dropdown {
  svg {
    min-width: 20px;
  }
}
.no-notification {
  flex-direction: column;
  .no-notification-img {
    height: 147px;
    background-color: #eae5f0;
    width: 147px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-bottom: 15px;
  }
  h5 {
    font-size: 16px;
    line-height: 44px;
    color: #212121;
    font-weight: bold;
  }
}
.badge-ntf {
  position: absolute;
  z-index: 9;
  top: 2px;
  left: 21px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #e80505;
}
.notification-top {
  background-color: $mainColor2;
  color: $mainColor1;
}
</style>
